import isEditableRaceCharacteristic from '../helpers/isEditableRaceCharacteristic'
import changeCombatReactionAdj from '../helpers/changeCombatReactionAdj'
import isEditableRaceAbility from '../helpers/isEditableRaceAbility'
import getRaceDefaults from '../helpers/getRaceDefaults'
import loadTraits from '../helpers/loadTraits'
import isEmpty from '../helpers/isEmpty'
//---------------------------
// process profile integrity
//---------------------------
export default function processProfileIntegrity({ change, character }) {
  console.log('-----------------------------------------')
  console.log('IN processProfileIntegrity change = ', change)
  //--------------
  // declare adjs
  //--------------
  let new_adjs = [] // new (ability) adjs - should be only one but kept as array for consistency
  let profile_changes = [] // for tracking profile changes
  let ability_changes = [] // for tracking/calc ability changes
  let characteristic_changes = [] // for tracking/calc characteristic changes
  //
  let ability_adjs = character.ability_adjs ? character.ability_adjs : []
  const queueCurrentCrAdjs = (fallbackAdj = null) => {
    const currentCrAdjs = ability_adjs.filter((adj) => adj?.name === 'cr')

    if (currentCrAdjs.length > 0) {
      new_adjs.push(
        ...currentCrAdjs.map((adj) => ({
          ...adj,
          source: 'ability',
        })),
      )
    } else if (fallbackAdj) {
      new_adjs.push({
        ...fallbackAdj,
        source: 'ability',
      })
    }
  }
  //-----------------
  // get change change
  //-----------------
  console.log('change.key = ' + change.key)
  //=======================================================
  // race change
  //-------------
  if (change.key == 'race_name') {
    //-------------------
    // get race defaults
    //-------------------
    let race_defaults = getRaceDefaults(change.value)
    //-----------------------------------
    // loop selected default race fields
    //-----------------------------------
    let keys = Object.keys(race_defaults)
    let vals = Object.values(race_defaults)
    //
    for (let i = 0; i < keys.length; i++) {
      console.log('race key = ', keys[i], ' val = ', vals[i])
      //--------------------------------------------------------------------
      // characteristic change - need to track these changes for db updates
      //--------------------------------------------------------------------
      if (isEditableRaceCharacteristic(keys[i])) {
        character[keys[i]] = vals[i]
        let change = {
          type: 'characteristic',
          key: keys[i],
          value: vals[i],
        }
        characteristic_changes.push(change)
        //-------------------------------------------------------------
        // ability change - need to track these changes for db updates
        //-------------------------------------------------------------
      } else if (isEditableRaceAbility(keys[i])) {
        continue
        //--------------
        // trait change
        //--------------
      } else if (keys[i] == 'trait_name' && !isEmpty(vals[i])) {
        //----------------------------------------------
        // update traits (need to check race has trait)
        //----------------------------------------------
        character[keys[i]] = vals[i]
        character.race_trait = vals[i]
        character = loadTraits({ character })
      } else {
        character[keys[i]] = vals[i]
      }
      //---------------
      // end for loop
      //---------------
    }
    //=======================================================
    // category change
    //-----------------
  } else if (change.key == 'category') {
    if (change.value == 'Enemy') {
      character.player = null
      let change = {
        type: 'profile',
        key: 'player',
        value: null,
      }
      profile_changes.push(change)
    } else if (change.value == 'Party') {
      character.combat_inclusion = true
      let change = {
        type: 'profile',
        key: 'combat_inclusion',
        value: true,
      }
      profile_changes.push(change)
    }
    //=======================================================
    // second weapon change
    //----------------------
  } else if (change.key == 'second_weapon') {
    console.log(
      'SECOND WEAPON CHANGE detected value = ',
      change.value,
      ' shield = ',
      character.shield,
      ' second_weapon = ',
      character.second_weapon,
    )
    //-------------------
    // add/remove cr adj
    //-------------------
    let res = changeCombatReactionAdj({
      character: character,
      key: change.key,
      toggle: change.value,
    })
    if (res) {
      if (res.adjs) {
        ability_adjs = res.adjs
      }
      queueCurrentCrAdjs(res.adj)
    }
    //
    if (change.value === true && character.shield === true) {
      console.log('SETTING SHIELD FALSE DUE TO SECOND WEAPON TRUE')
      character.shield = false
      let change = {
        type: 'ability',
        key: 'shield',
        value: false,
      }
      ability_changes.push(change)
    }
    //=======================================================
    // shield change
    //---------------
  } else if (change.key == 'shield') {
    console.log(
      'SHIELD CHANGE detected value = ',
      change.value,
      ' shield = ',
      character.shield,
      ' second_weapon = ',
      character.second_weapon,
    )
    //-------------------
    // add/remove cr adj
    //-------------------
    let res = changeCombatReactionAdj({
      character: character,
      key: change.key,
      toggle: change.value,
    })
    if (res) {
      if (res.adjs) {
        ability_adjs = res.adjs
      }
      queueCurrentCrAdjs(res.adj)
      //
      if (change.value === true && character.second_weapon === true) {
        console.log('SETTING SECOND WEAPON FALSE DUE TO SHIELD TRUE')
        character.second_weapon = false
        let change = {
          type: 'ability',
          key: 'second_weapon',
          value: false,
        }
        ability_changes.push(change)
      }
    }
    //=======================================================
    // gender/role checks
    //--------------------
    if (character.gender == 'Male') {
      //
      if (character.role == 'Sorceress') {
        character.role = 'Sorcerer'
        let change = {
          type: 'profile',
          key: 'role',
          value: 'Sorcerer',
        }
        profile_changes.push(change)
        //
      } else if (character.role == 'Priestess') {
        character.role = 'Priest'
        let change = {
          type: 'profile',
          key: 'role',
          value: 'Priest',
        }
        profile_changes.push(change)
      }
      //
    } else if (character.gender == 'Female') {
      //
      character.cock = 0
      let change = {
        type: 'profile',
        key: 'cock',
        value: 0,
      }
      profile_changes.push(change)
      //
      if (character.role == 'Sorcerer') {
        character.role = 'Sorceress'
        let change = {
          type: 'profile',
          key: 'role',
          value: 'Sorceress',
        }
        profile_changes.push(change)
        //
      } else if (character.role == 'Priest') {
        character.role = 'Priestess'
        let change = {
          type: 'profile',
          key: 'role',
          value: 'Priestess',
        }
        profile_changes.push(change)
      }
    }
  }
  //--------
  // return
  //--------
  return {
    character,
    new_adjs,
    ability_adjs,
    profile_changes,
    characteristic_changes,
    ability_changes,
  }
}
